var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    width: 200,
    height: 200,
    rx: 10,
    fill: "#FBDD3F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2689,
    y: 164.625,
    width: 160,
    height: 10,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7518,
    y: 166.125,
    width: 11,
    height: 7,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36.2916,
    y: 166.125,
    width: 11,
    height: 7,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8315,
    y: 166.125,
    width: 11,
    height: 7,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3716,
    y: 166.125,
    width: 11,
    height: 7,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 73.9116,
    y: 166.125,
    width: 11,
    height: 7,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 86.4515,
    y: 166.125,
    width: 11,
    height: 7,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 98.9915,
    y: 166.125,
    width: 11,
    height: 7,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 111.532,
    y: 166.125,
    width: 11,
    height: 7,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.6686 37.625L76.2936 21.65H71.2186L69.9186 31.3L68.5936 21.65H63.3186L65.8936 37.625H73.6686ZM83.5016 33.6C83.5016 33.625 83.4766 33.65 83.4516 33.65H82.2766C82.2516 33.65 82.2266 33.625 82.2266 33.6V25.7C82.2266 25.675 82.2516 25.65 82.2766 25.65H83.4516C83.4766 25.65 83.5016 25.675 83.5016 25.7V33.6ZM86.1016 37.625C87.8266 37.625 88.7016 36.975 88.7016 35.65V23.675C88.7016 22.325 87.8266 21.65 86.1016 21.65H79.6266C77.9016 21.65 77.0266 22.325 77.0266 23.675V35.65C77.0266 36.975 77.9016 37.625 79.6266 37.625H86.1016ZM98.5178 37.625V33.65H95.1428V21.65H89.9428V37.625H98.5178ZM108.588 37.625C110.313 37.625 111.188 36.975 111.188 35.65V21.65H105.988V33.6C105.988 33.625 105.963 33.65 105.938 33.65H104.763C104.738 33.65 104.713 33.625 104.713 33.6V21.65H99.5126V35.65C99.5126 36.975 100.388 37.625 102.113 37.625H108.588ZM130.603 37.625V23.875C130.603 22.575 129.203 21.65 127.403 21.65C125.778 21.65 124.653 21.875 123.878 22.85C123.303 22.05 122.553 21.65 121.028 21.65C119.528 21.65 118.278 22 117.653 22.675V21.65H112.453V37.625H117.653V25.7C117.653 25.675 117.678 25.65 117.703 25.65H118.878C118.903 25.65 118.928 25.675 118.928 25.7V37.625H124.128V25.7C124.128 25.675 124.153 25.65 124.178 25.65H125.403C125.428 25.65 125.453 25.675 125.453 25.7V37.625H130.603ZM140.711 37.625V33.65H137.086V31.65H140.636V27.65H137.086V25.65H140.686V21.65H131.886V37.625H140.711Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2734 125.583L66.2734 102.12C66.2734 93.7749 69.5885 85.7716 75.4893 79.8708C81.3901 73.97 89.3933 70.655 97.7383 70.655H103.512C111.857 70.655 119.86 73.97 125.761 79.8708C131.662 85.7716 134.977 93.7749 134.977 102.12L135.977 125.583",
    stroke: "black",
    strokeWidth: 6.92804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4274 103.046C73.4496 102.409 73.9843 101.91 74.6216 101.933L79.9876 102.12C80.7453 102.146 81.4904 102.322 82.1803 102.636C82.8702 102.951 83.4914 103.398 84.0085 103.952C84.5256 104.507 84.9284 105.158 85.1939 105.868C85.4594 106.578 85.5824 107.334 85.556 108.091L84.8105 129.44C84.757 130.97 84.0979 132.416 82.978 133.461C81.8582 134.505 80.3694 135.062 78.8391 135.008L73.4732 134.821C72.8358 134.798 72.3372 134.264 72.3595 133.626L73.4274 103.046Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.798 133.626C128.82 134.264 128.322 134.798 127.684 134.821L122.318 135.008C120.788 135.062 119.299 134.505 118.18 133.461C117.06 132.416 116.401 130.97 116.347 129.44L115.602 108.091C115.548 106.561 116.105 105.072 117.149 103.952C118.193 102.832 119.64 102.173 121.17 102.12L126.536 101.933C127.173 101.91 127.708 102.409 127.73 103.046L128.798 133.626Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.44b4521979b9e03df8c09564b7519bdc.svg";
export { ForwardRef as ReactComponent };